export const isNonEmptyString = text => {
  if (typeof text === 'string') {
    return text.trim().length > 0
  }
  return false
}

export default isNonEmptyString



// WEBPACK FOOTER //
// ./src/helpers/validations/is-non-empty-string.js